/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PlagiarismRunAssignmentParser = 
/* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['name', codecString],
    ['courseId', codecNumber, 'course_id'],
]);
export class PlagiarismRunAssignment extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PlagiarismRunAssignmentParser.decode(input).map(res => new PlagiarismRunAssignment(res));
    }
    static unsafeDecode(input) {
        return PlagiarismRunAssignment.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PlagiarismRunAssignmentParser.encode(data);
    }
    static schema() {
        return PlagiarismRunAssignmentParser.schema();
    }
}
